import { getProgressTextColors } from "../textColors";
import React from "react";
import { getFeedback } from "../../../services/moodle/courses";
import { useAuth } from "../../../contexts/AuthContext";
import { useTheme } from "../../../contexts/ThemeContext";
//f
export const ProgressRowItemDetail = ({ detail, includeFeedback, index }) => {
  const [feedback, setFeedback] = React.useState("-");
  const [generalFeedback, setGeneralFeedback] = React.useState("-");

  const theme = useTheme();
  const textColors = getProgressTextColors(theme.mode);
  const { user } = useAuth();

  const isEven = index % 2 === 1;

  React.useEffect(() => {
    if (detail.feedback && detail.feedback !== "") {
      setFeedback(detail.feedback);
    }

    if (
      detail.itemmodule === "quiz" &&
      detail.graderaw !== null &&
      detail.graderaw !== undefined &&
      detail.iteminstance
    ) {
      const args = {
        token: user.token,
        quizid: detail.iteminstance,
        grade: detail.graderaw,
      };
      getFeedback(args)
        .then((res) => {
          if (res?.feedbacktext) {
            setGeneralFeedback(res.feedbacktext);
          }
        })
        .catch((err) => {
          console.error("Error fetching quiz feedback:", err);
        });
    }
    //eslint-disable-next-line
  }, [detail]);

  const isDark = theme.mode === "dark";
  const borderColor = isDark ? "rgba(255, 255, 255, 0.15)" : "rgba(0, 0, 0, 0.08)";
  const cellBg = isDark ? "rgba(255, 255, 255, 0.02)" : "#FFFFFF";
  const titleColor = textColors.primary;
  const textColor = textColors.primary;

  return (
    <>
      <tr className="transition-colors duration-150">
        <th
          className="px-4 py-3.5 font-montserrat font-semibold text-[max(1rem,16px)] rounded-l-md"
          style={{
            backgroundColor: cellBg,
            borderLeft: `1px solid ${borderColor}`,
            borderTop: `1px solid ${borderColor}`,
            borderBottom: `1px solid ${borderColor}`,
            color: titleColor,
          }}
        >
          <p className="font-montserrat font-semibold text-[max(1rem,16px)] break-words whitespace-normal leading-snug">
            {detail.itemname}
          </p>
        </th>
        <td
          className={`px-4 py-3.5 font-montserrat text-[max(1rem,16px)] whitespace-nowrap ${!includeFeedback ? "rounded-r-md" : ""}`}
          style={{
            backgroundColor: cellBg,
            borderTop: `1px solid ${borderColor}`,
            borderBottom: `1px solid ${borderColor}`,
            borderRight: !includeFeedback ? `1px solid ${borderColor}` : undefined,
            color: textColors.primary,
          }}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.25rem",
              fontWeight: 700,
            }}
            dangerouslySetInnerHTML={{
              __html:
                detail.gradeformatted && detail.gradeformatted.split("(")[0],
            }}
          />
        </td>
        {includeFeedback && (
          <>
            <td
              className="px-4 py-3.5 font-montserrat text-[max(1rem,16px)]"
              style={{
                backgroundColor: cellBg,
                borderTop: `1px solid ${borderColor}`,
                borderBottom: `1px solid ${borderColor}`,
                color: textColor,
              }}
              dangerouslySetInnerHTML={{
                __html: feedback,
              }}
            ></td>
            <td
              className="px-4 py-3.5 font-montserrat text-[max(1rem,16px)] rounded-r-md"
              style={{
                backgroundColor: cellBg,
                borderTop: `1px solid ${borderColor}`,
                borderBottom: `1px solid ${borderColor}`,
                borderRight: `1px solid ${borderColor}`,
                color: textColor,
              }}
              dangerouslySetInnerHTML={{
                __html: generalFeedback,
              }}
            ></td>
          </>
        )}
      </tr>
    </>
  );
};
